export default "/_next/static/images/2020-3x-51455272b947ea805b11f3220f993696.png";